module.exports = __webpack_public_path__ + "6.png?7d86b3ed717c786b4978342d7a7a1ebd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cartoon/6.png
// module id = 207
// module chunks = 0